/**
 * The Maklan Monogram — a bespoke luxury identity mark.
 *
 * A shield / hexagon frame in hairline gold containing a geometric
 * capital M formed by two peaks. Timeless enough for embroidery,
 * key fobs, favicons, packaging and signage.
 *
 * Uses `currentColor` for the stroke, letting parent elements set the tint
 * (gold on dark, dark on gold). All sizing driven by width/height props.
 */
export default function MaklanMonogram({ size = 32, tone = "gold", withWordmark = false, className = "" }) {
  const stroke = tone === "gold" ? "#C5A059" : tone === "ink" ? "#050814" : "currentColor";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size * 1.4}
        viewBox="0 0 60 84"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Outer hairline shield */}
        <path
          d="M30 2 L58 12 L58 60 L30 82 L2 60 L2 12 Z"
          stroke={stroke}
          strokeWidth="0.9"
          strokeLinejoin="miter"
        />
        {/* Inner shield */}
        <path
          d="M30 9 L52 17.5 L52 57 L30 74 L8 57 L8 17.5 Z"
          stroke={stroke}
          strokeWidth="0.5"
          opacity="0.55"
        />
        {/* Geometric M */}
        <path
          d="M14 58 L14 26 L30 46 L46 26 L46 58"
          stroke={stroke}
          strokeWidth="1.4"
          strokeLinejoin="miter"
          strokeLinecap="square"
        />
        {/* Baseline serif tick */}
        <line x1="18" y1="62" x2="42" y2="62" stroke={stroke} strokeWidth="0.5" opacity="0.7" />
        {/* Est diamond */}
        <path d="M30 68 l3 3 l-3 3 l-3 -3 z" fill={stroke} opacity="0.7" />
      </svg>
      {withWordmark && (
        <span className="flex flex-col leading-tight">
          <span className="font-display text-[1.35em] tracking-[0.24em] uppercase" style={{ letterSpacing: "0.24em" }}>
            Maklan
          </span>
          <span className="text-[0.55em] tracking-[0.32em] uppercase text-white/50 mt-1">
            Motors
          </span>
        </span>
      )}
    </span>
  );
}
